import "./style.css";

import React from "react";

interface IAudioTimeDisplayProps {
  currentTime: number;
  duration: number;
  formatTime: (time: number) => string;
}

const AudioTimeDisplay: React.FC<IAudioTimeDisplayProps> = ({
  currentTime,
  duration,
  formatTime,
}) => (
  <span className="audio-time">
    {formatTime(currentTime)} / {formatTime(duration)}
  </span>
);

export default AudioTimeDisplay;
